export const baseUrl = process.env.REACT_APP_SERVICE_URL;
export const supportUrl = process.env.REACT_APP_SUPPORT_URL;
export const cleanUrl = baseUrl.replace(/^https:\/\//, '');
export const token = process.env.REACT_APP_TOKEN;

export const baseApiUrl = `${baseUrl}/api/v2`;
export const getNetworksApiUrl = `${baseApiUrl}/carriers`;
export const getNetworksLogosApiUrl = `${baseApiUrl}/carriers/logo`;
export const getPaymentMethodsApiUrl = `${baseApiUrl}/gift/payment-methods`;
export const getTransferTypesApiUrl = `${baseApiUrl}/transfer-types`;
export const getConversionRateApiUrl = `${baseApiUrl}/conversion-rate/guest`;
export const postPretransferApiUrl = `${baseApiUrl}/transfers/pretransfer`;
export const postTransferApiUrl = `${baseApiUrl}/transfers`;
export const getUserLocationInfoExtApiUrl = `https://pro.ip-api.com/json?key=9pNNNfpt4V0yhgq`;
export const getIfGuestPaymentIsEnabled = `${baseApiUrl}/configurations/guest-top-up`;
